import React from 'react';
import {HashRouter as Router, Routes, Route} from "react-router-dom";
import MissioForm from "./features/missio-form/MissioForm";

function App() {
    return (
        <div className="App" style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '50px',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <img src="./logo.png" alt="missio"/>
            <Router>
                <Routes>
                    <Route path="/" element={<MissioForm/>}/>
                </Routes>
            </Router>
        </div>
    );
}

export default App;
